import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "sps-zero-state",
    templateUrl: "./sps-zero-state.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsZeroStateComponent {
    @Input() artwork = "";
    @Input() heading: string;
    @Input() subHeading: string;
}
